import { getRgbaColor } from "../shared/utils/color/color";
const colorPalette = {
    deepSpace: '#0B2032',
    geotabDark: '#21325E',
    geotab: '#25477B',
    innovationDark: '#0059B2',
    innovation: '#0078D3',
    curveLogic: '#00AEFF',
    curveLogicLight: '#4DC6FF',
    snow: '#FFFFFF',
    ice: '#FAFCFF',
    steam: '#F5F7FB',
    cloud: '#EFF2F7',
    dust: '#D9E0E8',
    smoke: '#D1D6DD',
    mist: '#EBF6FF',
    mineral: '#E7EDF2',
    haze: '#C0CCD8',
    graphite: '#748FAA',
    slate: '#66788C',
    blackTarr: '#3C5164',
    silver: '#98ADBD',
    polar: '#D0E2F1',
    ember: '#FE5A3F',
    emberDark: '#CA290E',
    emberLight: '#FFEEEC',
    mustard: '#F9BA00',
    mustardDark: '#8A6500',
    mustardLight: '#FEF8E5',
    rose: '#EDBBB2',
    meadow: '#00AA00',
    meadowDark: '#008100',
    meadowLight: '#EBFBEB',
};
export const colors = {
    core: colorPalette,
    transparent: 'rgba(255,255,255,0)',
    text: {
        primary: colorPalette.geotab,
        secondary: colorPalette.blackTarr,
        tertiary: colorPalette.slate,
        inversePrimary: colorPalette.snow,
        inverseSecondary: colorPalette.mineral,
        inverseTertiary: colorPalette.polar,
        placeholder: colorPalette.haze,
        disabled: colorPalette.silver,
        activePrimary: colorPalette.innovation,
        activeSecondary: colorPalette.innovationDark,
        activeTertiary: colorPalette.blackTarr,
        inverseActivePrimary: colorPalette.snow,
        inverseActiveSecondary: colorPalette.curveLogic,
    },
    border: {
        primary: colorPalette.haze,
        secondary: colorPalette.graphite,
        disabled: colorPalette.slate,
        inversePrimary: colorPalette.snow,
        activePrimary: colorPalette.innovation,
        activeSecondary: colorPalette.innovationDark,
        activeTertiary: colorPalette.curveLogic,
    },
    background: {
        white: colorPalette.snow,
        lightest: colorPalette.ice,
        lighter: colorPalette.steam,
        light: colorPalette.cloud,
        medium: colorPalette.dust,
        dark: colorPalette.geotab,
        darker: colorPalette.geotabDark,
        darkest: colorPalette.deepSpace,
    },
    action: {
        innovation: colorPalette.innovation,
        innovationDark: colorPalette.innovationDark,
        curveLogic: colorPalette.curveLogic,
        curveLogicLight: colorPalette.curveLogicLight,
        geotab: colorPalette.geotab,
        geotabDark: colorPalette.geotabDark,
        geotabDarkest: colorPalette.deepSpace,
        white: colorPalette.snow,
        paleGray: colorPalette.cloud,
        lightGray: colorPalette.dust,
        ember: colorPalette.ember,
        emberDark: colorPalette.emberDark,
        emberLight: colorPalette.emberLight,
        mustard: colorPalette.mustard,
        mustardDark: colorPalette.mustardDark,
        mustardLight: colorPalette.mustardLight,
        rose: colorPalette.rose,
        meadow: colorPalette.meadow,
        meadowDark: colorPalette.meadowDark,
        meadowLight: colorPalette.meadowLight,
        disabled: colorPalette.smoke,
        active: colorPalette.mist,
    },
};
export const gradients = {
    primary: `linear-gradient(90deg, ${getRgbaColor(colors.background.darkest, 0.95)} 0%, c 61.46%, ${getRgbaColor(colors.core.innovation, 0)} 100%)`,
    secondary: `linear-gradient(88.26deg, rgba(0, 51, 127, 0.75) 0%, ${getRgbaColor(colors.core.innovation, 0.75)} 100%)`,
    tertiary: `linear-gradient(90deg, ${getRgbaColor(colors.background.darkest, 0.95)} 0%, ${getRgbaColor(colors.background.darkest, 0.75)} 50%, ${getRgbaColor(colors.background.darkest, 0)} 75%, ${getRgbaColor(colors.background.darkest, 0)} 100%)`,
};
export const overlays = {
    primary: getRgbaColor(colors.background.darkest, 0.7),
    secondary: getRgbaColor(colors.background.darker, 0.75),
    active: getRgbaColor(colors.core.innovation, 0.3),
    activeSecondary: getRgbaColor(colors.core.mist, 0.7),
};
